import React from 'react';
import {ANALYTICS_CHANNEL_LABELS} from 'helpers/constants/analytics';
import CheckboxMultiSelect from 'components/select/CheckboxMultiSelect';
import {
  useAnalyticsFilters,
  useAnalyticsFiltersUpdate
} from 'components/AnalyticsFilters/AnalyticsFiltersContext';

const AnalyticsChannelPicker = () => {
  const {channelTypes, availableChannelTypes} = useAnalyticsFilters();
  const {setChannelTypes} = useAnalyticsFiltersUpdate();

  // BFF returns channel keys in the same format used for filtering. Empty /
  // missing list means only "All Channels" is shown.
  const options = availableChannelTypes.map((value) => ({
    value,
    label: ANALYTICS_CHANNEL_LABELS[value] ?? value
  }));

  return (
    <CheckboxMultiSelect
      labelId='analytics-channel-select-label'
      allLabel='All Channels'
      ariaLabel='Analytics channels'
      options={options}
      selected={channelTypes}
      onChange={setChannelTypes}
    />
  );
};

export default AnalyticsChannelPicker;
